"use es6";

import { createMotionProxy } from "./motion-proxy";
import { createDomMotionConfig } from "./utils/create-config";

/**
 * @public
 */
const m = createMotionProxy(createDomMotionConfig);
export { m };